import React from 'react'
import { RouterProvider } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'

import { router } from '@/app/router'
import { ThemeProvider } from '@/components/ui/theme-provider'
import '@/core/i18n' // Initialize i18n

/**
 * Application providers wrapper
 * Centralizes all context providers for the application
 */
export const AppProviders: React.FC = () => {
  return (
    <ThemeProvider defaultTheme="light" storageKey="ui-theme">
      {/* React Router */}
      <RouterProvider router={router} />
      
      {/* Global Toast Notifications */}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: 'hsl(var(--background))',
            color: 'hsl(var(--foreground))',
            border: '1px solid hsl(var(--border))',
          },
          success: {
            iconTheme: {
              primary: 'hsl(var(--primary))',
              secondary: 'hsl(var(--primary-foreground))',
            },
          },
          error: {
            iconTheme: {
              primary: 'hsl(var(--destructive))',
              secondary: 'hsl(var(--destructive-foreground))',
            },
          },
        }}
      />
    </ThemeProvider>
  )
} 